import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShopManagerComponent } from './shop-manager.component';
import { LandingService } from '../modules/shop/services/landing.service';
const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: ShopManagerComponent, children:[
      {
        path: '',
        loadChildren: () =>
          import('../modules/shop/shop.module').then((m)=> m.ShopModule),
        resolve: {
          slider: () => inject(LandingService).requestDataSlider(),
          product: () => inject(LandingService).requestDataPopularProduct(),
          category: () => inject(LandingService).requestDataPopularCategory(),
        }
      },
      {
        path: '',
        loadChildren: () =>
          import('../modules/main-module/main-module.module').then((m)=> m.MainModuleModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('../modules/event-management/event-management.module').then((m) => m.EventManagementModule)
      }
    ]}
    
  ])],
  exports: [RouterModule]
})
export class ShopManagerRoutingModule { }
